import { useEffect, useState, useRef } from "react"
import { Link, useNavigate } from "react-router-dom";
import styles from './cssModules/index.module.css';
import inactivity from './gallary/inactivity.png';

export default function ReturnDB({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    const userUrl = process.env.REACT_APP_API_URL;
    let S3_URL = process.env.REACT_APP_S3_URL;

    const [totalItems, setTotalItems] = useState();
    const [totalValue, setTotalValue] = useState();
    const [prodls, setProdLs] = useState();

    const [form, setForm] = useState({});

    const [pageno, setPageno] = useState(1);
    const [noOfObs, setNoOfObs] = useState(null);

    const navigate = useNavigate();

    const renderCount = useRef(0);

    let jToken = localStorage.getItem('token');

    const monthVal = {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
    }

    const yearVal = Array.from({ length: 10 }, (_, index) => index + 2025);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/api/returns`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: "include"
                })
                if (response.status === 500) {
                    throw new Error('Error while laoding return dashboard');
                } else {

                    if (response.status !== 200) {
                        await loginStatus();
                        navigate('/login');
                    }
                }

                let role = await response.json();
                if (role.role === 'designer'){
                    navigate('/unauthorized');
                }
            } catch (error) {
                navigate('/error');
                console.log(error.message);
            }
        }
        fetchData();
    }, [jToken, loginStatus, apiURL, navigate])

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const formdata = new FormData(event.target);
            const formObject = {}
            formdata.forEach((value, key) => {
                formObject[key] = value
            })
            setForm(formObject);
            setPageno(1);
            const response = await fetch(`${apiURL}/api/returns`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'key': 'form',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    filter: formObject,
                    pageNo: 1
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error while fetching seller return data');
            } else {

                if (response.status === 200) {
                    const res = await response.json();
                    setTotalItems(res.metrics.returnedItems);
                    setTotalValue(res.metrics.totalReturnedPrice ? res.metrics.totalReturnedPrice : 0);
                    setProdLs(res.prod);
                    setNoOfObs(res.noObs);
                    renderCount.current += 1;
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            await loginStatus();
            navigate('/login');
            console.log(error.message);
        }
    }

    const changePage = async (event, ind) => {
        event.preventDefault();
        try {
            const increment = !ind ? 1 : -1;
            const response = await fetch(`${apiURL}/api/returns`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'key': 'page',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    filter: form,
                    pageNo: pageno + increment
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error while changing the page in user return page');
            } else {

                if (response.status === 200) {
                    const res = await response.json();
                    setProdLs(res.prod);
                    setNoOfObs(res.noObs);
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            await loginStatus();
            navigate('/login');
            console.log(error.message);
        }
    }

    return (
        <>
            <div className={`${styles.sellerDashboard}`}>
                <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontSize: '20px', fontWeight: '700', letterSpacing: '1px' }}>Check your return status here</span>
                    <form id='selectDate' onSubmit={handleSubmit} className={`${styles.sellerDBForm}`}>
                        <div className={`${styles.sellerDBSelectionDiv}`}>
                            <select name='month' form="selectDate" className={`${styles.sellerDBformSelect}`}>
                                {Object.entries(monthVal).map((elem) => {
                                    return (
                                        <>
                                            <option value={elem[0]} key={elem}>{elem[1]}</option>
                                        </>
                                    )
                                })}
                            </select>
                            <select name='year' form="selectDate" className={`${styles.sellerDBformSelect}`}>
                                {yearVal.map((elem) => {
                                    return (
                                        <>
                                            <option value={elem} key={elem}>{elem}</option>
                                        </>
                                    )
                                })}
                            </select>
                        </div>
                        <input type="submit" value='GO!' className={`${styles.sellerDBforminput}`} />
                    </form>
                </div>
            </div>
            {
                (parseInt(totalItems) === 0) && (renderCount.current > 0) ?
                    (<>
                        <div className={`${styles.noNotificationDivSelect}`}>
                            <span className={`${styles.noNotificationSpan}`}>
                                No activity
                            </span>
                            <img src={inactivity} alt='Inactivity' style={{ height: '60px' }} />
                        </div>
                    </>) :
                    (
                        <>
                            <div className={`${styles.sellerDBMetricsDIV}`} style={parseInt(totalItems) === 0 ? { display: 'none' } : {}}>
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span>
                                        {'Total returned items'.toUpperCase()}
                                    </span>
                                    <span>{totalItems}</span>
                                </div>
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span>
                                        {'Total returned value'.toUpperCase()}
                                    </span>
                                    <span>{totalValue}  INR</span>
                                </div>
                            </div>

                            <div>
                                <div className={`${styles.sellerDBPRODLS}`}>
                                    {prodls && prodls.map((item, index) => {
                                        return (
                                            <div className={`${styles.sellerOrderMainDiv}`}>
                                                <Link className={`${styles.sellerReturnDBAnchor}`} to={`${userUrl}/product/${item.id}`} target="_blank">
                                                    <span className={`${styles.sellerReturnDBFont}`} style={{ alignSelf: 'center' }}>{item.name}</span>
                                                    <div>
                                                        <img className={`${styles.sellerDBPRODIMG}`} id={index} src={`${S3_URL}/${item.photo1}`} alt={index}></img>
                                                    </div>
                                                    <div className={`${styles.sellerOrderAddressDiv}`}>
                                                        <span className={`${styles.sellerReturnDBFont}`}>Name: {item.fname} {item.lname}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>House no: {item.houseno}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>Road: {item.roadName}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>Area:{item.areaName}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>City {item.city}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>Pin: {item.pin}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>Ph no. {item.phoneNo}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>Alt. Ph. No.{item.altPhoneNo}</span>
                                                        <span className={`${styles.sellerReturnDBFont}`}>Price: {item.price}</span>
                                                    </div>
                                                </Link>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div style={noOfObs < 10 ? { display: 'none' } : { display: 'block' }}>
                                    <button onClick={(e) => { changePage(e, true); setPageno(pageno - 1) }} style={pageno < 2 ? { display: 'none' } : { display: 'block' }}>Prev</button>
                                    <span>{pageno}</span>
                                    <button onClick={(e) => { changePage(e, false); setPageno(pageno + 1) }} >Next</button>
                                </div>
                            </div>
                        </>
                    )
            }

        </>
    )
}